<div class="m-b-24">
    <div class="m-t-12 flex gap-4 rounded-lg p-18"
        [ngClass]="type == 'limit_exceed' ? 'bg-bg-color-red':'bg-bg-color-blue'">
        <div class="flex gap-3">
            <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C19.9939 15.5203 15.5203 19.9939 10 20ZM9 13V15H11V13H9ZM9 5V11H11V5H9Z"
                        attr.fill="{{type == 'limit_exceed' ? '#E94444':'#0361F0'}}" />
                </svg>
            </span>
            <span class="font-medium text-black" *ngIf="type == 'limit_exceed'">
                <div class="text-black self-center">
                    <div class="font-bold m-b-8">Daily {{transactionType}} Limit Exceeded</div>
                    <div class="m-b-8">The amount you entered is greater than what is left of your daily limit.</div>
                    <div class="m-b-8">Daily Limit: <span class="font-bold ">{{dailyWebTransactionLimit | majorAmount |
                            currency:"₦"}}</span></div>
                    <div>Left to Spend today: <span class="font-bold ">{{remainingAmount | majorAmount |
                            currency:"₦"}}</span></div>
                    <div class="m-t-20 m-b-8 font-bold text-primary cursor-pointer">
                        <span *ngIf="!showEditTransferLimitModal"
                            nzTooltipTitle="Kindly reach out to your Business Relationship Manager to have your limits increased."
                            nzTooltipPlacement="bottom" nz-tooltip [nzTooltipColor]="'white'"
                            nzTooltipOverlayClassName="custom-tooltip-col"
                            [nzTooltipTrigger]="isMobile ? 'click':'hover'">
                            Increase Limit?
                        </span>
                        <span *ngIf="showEditTransferLimitModal" (click)="createEditTansferLimitModal()">
                            Increase Limit?
                        </span>
                    </div>
                </div>
            </span>
            <span class="font-medium text-black" *ngIf="type == 'transfer_splitting'">
                <div class="text-black self-center">
                    <div class="font-bold m-b-8">Transfer Splitting</div>
                    <div class="m-b-8">Proceeding will attempt to make 3 separate transfers instantly to your
                        beneficiary.</div>
                    <div class="m-b-8">Single Transfer Limitt: <span class="font-bold ">₦100,000.00</span></div>
                </div>
            </span>
        </div>

    </div>
</div>